import { Component } from "react";

class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error(error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-page" role="alert">
          <h1 className="h1 fc__0E1218 mb__16">Something went wrong</h1>
          <p className="fb__16 fc__5F636A mb__10">We couldn't load this page. Please try again.</p>
          <button onClick={() => window.location.reload()}>Reload page</button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;